// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9h-0";
export var orangeButton = "_9h-1";